import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExamsbarService {
  /** ExamComponent → ExamsbarComponent: force a page switch */
  readonly switchPage$ = new Subject<string>();
  /** ExamsbarComponent → ExamComponent: user changed page */
  readonly pageChange$ = new Subject<string>();
  /** ExamsbarComponent → ExamComponent: user clicked "open patient details" */
  readonly showPatDetails$ = new Subject<void>();
  /** ExamComponent → ExamsbarComponent: user scrolled past the page edge, move to the next/previous tab */
  readonly scrollNav$ = new Subject<'next' | 'prev'>();
  /** Set by ExamsbarComponent: the tab before/after the current one (for the scroll hint), or null at the ends */
  neighbor: (dir: 'next' | 'prev') => { page: string; label: string } | null = () => null;
}
